// extracted by mini-css-extract-plugin
export var columnList = "_ea-0";